import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import colors from '../../colorPalette';
import ActionButton from './ActionButton';
import Item from './Item';
const Wrapper = styled.div `
  position: relative;
  table {
    width: 100%;
    table-layout: fixed;
    thead {
      background-color: ${colors.darkGrey};
      position: sticky;
      top: 0;
    }
    th {
      background-color: ${colors.black};
      color: ${colors.white};
      white-space: nowrap;
      &.small {
        width: 100px;
        text-align: right;
      }
    }
  }
`;
const Placeholder = styled.p `
  margin: 0;
  font-style: italic;
  color: ${colors.lightGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
const Table = ({ items, onAdd, onEdit, onRemove, columns, itemColumn = 'Item', placeholder, className, }) => {
    const [insertionMode, setInsertionMode] = useState(false);
    const hasActions = Boolean(onAdd || onEdit || onRemove);
    return (_jsx(Wrapper, { className: className, children: items.length === 0 && placeholder
            ? _jsx(Placeholder, { children: placeholder })
            : (_jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [!columns && itemColumn && _jsx("th", { children: itemColumn }), columns?.map(column => (_jsx("th", { children: column.label }, column.name))), hasActions && (_jsx("th", { className: "small", children: _jsx(ActionButton, { onClick: () => setInsertionMode(true), children: "\u2795" }) }))] }) }), _jsxs("tbody", { children: [insertionMode && onAdd && (_jsx(Item, { editMode: true, hasActions: true, columns: columns, onEdit: (item) => {
                                    setInsertionMode(false);
                                    onAdd(item);
                                }, onCancel: () => setInsertionMode(false) })), items.map(item => (_jsx(Item, { item: item, columns: columns, onEdit: onEdit && item.id
                                    ? newItem => onEdit(item.id, newItem)
                                    : undefined, onRemove: onRemove && item.id
                                    ? () => onRemove(item.id)
                                    : undefined, hasActions: hasActions }, item.id)))] })] })) }));
};
export default Table;
